import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import cslx from 'clsx';
import Input from '../Input/Input';
import { IFormInput } from '../types';

interface InputFieldProps {
  register: UseFormRegister<IFormInput>;
  name: keyof IFormInput;
  errors: FieldErrors<IFormInput>;
  setValue: UseFormSetValue<IFormInput>;
  required?: boolean;
  type?: string;
  t: (key: string) => string;
  value?: string | number;
}

export default function InputField({
  register,
  name,
  errors,
  setValue,
  required = false,
  type = 'text',
  t,
  value,
}: InputFieldProps) {
  const camelToUnderscore = (str: string) => {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
  };

  return (
    <div className="w-full">
      <Input
        {...register(name, { required })}
        error={errors[name]?.message}
        type={type}
        label={t(`create_user_modal.${camelToUnderscore(name)}`)}
        placeholder={t(`create_user_modal.${camelToUnderscore(name)}`)}
        onChange={(_, value) => setValue(name, value.toString())}
      />
      {errors[name] && (
        <p className="absolute text-1-2 italic text-red">
          {t(`create_user_modal.${camelToUnderscore(name)}`)}{' '}
          {t('global.is_required')}
        </p>
      )}
    </div>
  );
}
